export default "__VITE_ASSET__Gt1h0dNx__"